import { MCPConfigSnippet } from '../../../../src/components/Product/MCP/MCPConfig';
import * as React from 'react';
export default {
  MCPConfigSnippet,
  React
};